import React from 'react';
import styled from 'styled-components';
import { Dialog } from '@material-ui/core';

import { Flex, Grid, Text } from 'Components/Base';

const DotLoaderWrapper = styled((props) => (
  <Grid
    gridColumnGap="5px"
    gridTemplateColumns="repeat(4, 10px)"
    height={50}
    width={50}
    {...props}
  />
))`
  span {
    width: 10px;
    height: 10px;
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 50%;
    animation: dots1 1s infinite ease-in-out;
  }

  span:nth-child(1) {
    animation-delay: 0.2s;
  }

  span:nth-child(2) {
    animation-delay: 0.3s;
  }

  span:nth-child(3) {
    animation-delay: 0.4s;
  }

  span:nth-child(4) {
    animation-delay: 0.5s;
  }

  @keyframes dots1 {
    0% {
      transform: translateY(0px);
      background: ${({ theme }) => theme.colors.primary};
    }
    50% {
      transform: translateY(10px);
      background: ${({ theme }) => theme.colors.primary};
    }
    100% {
      transform: translateY(0px);
      background: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const DotLoader = () => {
  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center">
      <DotLoaderWrapper>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </DotLoaderWrapper>
      <Text mt={6} textStyle="caption">
        กำลังอัปโหลด...
      </Text>
    </Flex>
  );
};

const LoadingModal = ({ isOpen, ...props }) => {
  return (
    <Dialog open={isOpen} {...props}>
      <Flex justifyContent="center" alignItems="center" minHeight="150px" minWidth="150px">
        <DotLoader />
      </Flex>
    </Dialog>
  );
};

export default LoadingModal;
